import React, { useState } from 'react';

import type { ToolbarContextType } from './../../../../ricos-context';
import { withToolbarContext } from './../../../../ricos-context';
import { getIsModalOpen, useModalState } from './../../../../ricos-modals/modal-service-provider';
import type { IToolbarItem } from './../../../../ricos-types/toolbarTypes';
import { lineSpacingModals } from './../../../../plugin-line-spacing/consts';

import { DropdownArrowIcon } from '../../../icons';
import { ToolbarButton } from '../ToolbarButton';

const LineSpacingButton = ({
  toolbarItem,
  context,
  dataHook,
}: {
  toolbarItem: IToolbarItem;
  context: ToolbarContextType;
  dataHook?: string;
}) => {
  const { isMobile, t } = context || {};
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);
  const Icon = toolbarItem.presentation?.icon;
  const tooltip = t(toolbarItem.presentation?.tooltip);
  const isLineSpacingModalOpen = useModalState(getIsModalOpen(lineSpacingModals.spacingOptions));
  const isCustomLineSpacingModalOpen = useModalState(
    getIsModalOpen(lineSpacingModals.customSpacing)
  );

  return (
    <ToolbarButton
      ref={setReferenceElement}
      disabled={toolbarItem.attributes.disabled}
      isMobile={isMobile}
      active={isLineSpacingModalOpen || isCustomLineSpacingModalOpen}
      tooltip={tooltip}
      onClick={e => toolbarItem.commands?.click({ referenceElement, clickFromKeyboard: !e.detail })}
      icon={() => (
        <>
          <Icon />
          <DropdownArrowIcon />
        </>
      )}
      dataHook={dataHook}
    />
  );
};

export default withToolbarContext(LineSpacingButton);
